import { render, staticRenderFns } from "./DropdownMenu.vue?vue&type=template&id=bad22d90&"
import script from "./DropdownMenu.vue?vue&type=script&setup=true&lang=js&"
export * from "./DropdownMenu.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bad22d90')) {
      api.createRecord('bad22d90', component.options)
    } else {
      api.reload('bad22d90', component.options)
    }
    module.hot.accept("./DropdownMenu.vue?vue&type=template&id=bad22d90&", function () {
      api.rerender('bad22d90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/components/ui/dropdown/DropdownMenu.vue"
export default component.exports